import { Component, OnInit } from '@angular/core';
import { SignatureComponent, AccordionComponent } from '@ppl/ui';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { LoggerService } from '../../../shared/services/logger.service';
import { MEMBER_VIEW_PAGE_IDS, PAGE_CONSTANTS, TABS } from '../../../shared/constants/page.constants';
import { ENROLLMENT_TYPE_BACKEND_MAPPINGS, STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { NotificationService } from '../../../shared/services/notification.service';
import { CommonModule } from '@angular/common';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { UserService } from '../../../services/user.service';
import { SectionsService } from 'src/app/services/sections.service';

@Component({
  selector: 'ppl-lead-detail-signature',
  standalone: true,
  imports: [SignatureComponent, AccordionComponent, AuthorizeDirective, NgZorroModule, CommonModule],
  templateUrl: './lead-detail-signature.component.html',
  styleUrl: './lead-detail-signature.component.css'
})


export class LeadDetailSignatureComponent extends BaseComponent implements OnInit {


  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  tabId = TABS.Signature;

  updateSignature = false;
  signatureData: any;
  mode = "read";
  copyOfGridData: any = [];

  customNote = '';
  entry = 'base';
  selectedLead: any;
  program: any;
  steps: any;
  entrys: any;
  imageUrl: any;
  isLoading = false;
  isEditable = true;
  isEmployerFlow = false;

  constructor(
    private leadDetailsService: LeadDetailsService,
    private logger: LoggerService,
    private notificationService: NotificationService,
    private authUtility: AuthorizationUtility,
    private sectionService: SectionsService,
    private userService: UserService
  ) {
    super();
  }

  ngOnInit() {
    this.isEditable = this.authUtility.isSectionEditable(this.pageId, this.tabId, "Signature");

    //this.entrys = this.userService.getLeadEntry() ?? '';
    this.entry = ((this.userService.getLeadEntry()) === 'participantEnrollment') ? 'participant' : 'provider';
    // this.pageId = this.entry == 'participant' ? PAGE_CONSTANTS.PARTICIPANT_INFORMATION : PAGE_CONSTANTS.PROVIDER_INFORMATION;
    this.program = this.userService.getSelectedProgram();
    const enrollmentType = this.sectionService.getEnrollmentType();
    this.isEmployerFlow = enrollmentType.indexOf(ENROLLMENT_TYPE_BACKEND_MAPPINGS['EMP']) > -1;
    if(this.isEmployerFlow) {
      this.customNote = STATIC_DATA.SIGNATURE_EMPLOYER_CUSTOM_NOTE;
    }
    try {
      this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    } catch {
      this.notificationService.alert("error", "Error Fetching Data", "Error getting selected lead data");
    }
    this.getSignatureData(false);
  }

  getSignatureData(readReplica: boolean) {
    this.isLoading = true;
    this.leadDetailsService.fetchLeadSignatureDetailsApi(this.program.program_code, this.selectedLead, this.entry, readReplica).subscribe({
      next: (data) => {
        this.isLoading = false;
        if (data?.responsedata && data.responsedata.length > 0) {
          const activeSign = data?.responsedata.find((data: any) => data.isActive);
          this.updateSignature = true;
          this.imageUrl = activeSign?.signatureImageBase64 ? `data:image/png;base64,${activeSign?.signatureImageBase64}` : undefined;
        }
      }, error: () => {
        this.isLoading = false;
      }
    });
  }


  add(): void {
    this.mode = 'add';
  }

  fieldsChanged(event: any) {
    const program = this.userService.getSelectedProgram();
    if (event.isEntered) {
      const base64Data = event.dataURL.split(',')[1];
      const payload = {
        value: event.name,
        signatureImage: base64Data,
        id: this.selectedLead,
        type: ((this.userService.getLeadEntry()) === 'participantEnrollment') ? 'participant' : 'provider',
        programCode: program?.program_code,
      }
      console.log(payload);
      this.leadDetailsService.saveSignature(payload, true).subscribe(() => {
        this.updateSignature = true;
        this.getSignatureData(true);
      })
    }
    else {
      this.updateSignature = true;
      this.getSignatureData(false);
    }
  }

  handleSignatureError(error: string): void {
    this.notificationService.alert('error', 'Signature Error', error);
  }
}
